import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Analisis/cambiarAnalisisVigiladoSeleccion`, method: 'POST', body: {list}, token: token})
}